import styled from 'styled-components'

import { IconProps } from '@/components/Icons'
import BaseSvg from '@/components/Icons/BaseSvg'

const StyledIcon = styled<any>(BaseSvg)`
  width: 20px;
  height: 20px;
`
const UserLookupIcon = (props: IconProps) => (
  <StyledIcon viewBox="0 0 24 24" fill="none" {...props}>
    <g
      fill="#002AB4"
      stroke="#002AB4"
      strokeLinecap="square"
      strokeLinejoin="miter"
      strokeMiterlimit="10"
      strokeWidth="2"
    >
      <polyline fill="none" points="22 22 15.657 15.657 16.065 16.065" stroke="#002AB4" />
      <circle cx="10" cy="10" fill="none" r="8" stroke="#002AB4" />
      <circle cx="10" cy="7" r="2" stroke="none" />
      <path
        d="M10,10h0c1.76,0,3.254,1.136,3.789,2.715,.214,.633-.294,1.285-.962,1.285H7.173c-.668,0-1.177-.652-.962-1.285,.535-1.579,2.029-2.715,3.789-2.715Z"
        stroke="none"
      />
    </g>
  </StyledIcon>
)

UserLookupIcon.displayName = 'UserLookup'
export default UserLookupIcon
